import React from "react";
import PropTypes from "prop-types";

import GBLoginForm from "../../../Library/Forms/GBLoginForm";

import * as GBConst from "../../GB/NonComponents/GBConst";

import * as DMConst from "../NonComponents/DMConst";
import DMWelcomeForm from "../Forms/DMWelcomeForm";
import DMCoverageForm from "../Forms/DMCoverageForm";
import DMDashboardForm from "../Forms/DMDashboardForm";
import DMTargVsPriorAchievForm from "../Forms/Results/DMTargVsPriorAchievForm";
import DMProgCovByAgeGroupForm from "../Forms/Results/DMProgCovByAgeGroupForm";
import DMProgCovBySNUForm from "../Forms/Results/DMProgCovBySNUForm";
import DMCovByAgeSNUForm from "../Forms/Results/DMCovByAgeSNUForm";
import DMImpactHIVInfAvertedForm from "../Forms/Results/DMImpactHIVInfAvertedForm";
import DMVMMCsReqPerHIVInfAvertedForm from "../Forms/Results/DMVMMCsReqPerHIVInfAvertedForm";
import DMProgCovByCountryForm from "../Forms/Results/DMProgCovByCountryForm";
import DMCovTableByAgeCountryForm from "../Forms/Results/DMCovTableByAgeCountryForm";
import DMAPA1Form from "../Forms/Results/DMAPA1Form";
import DMAPA2Form from "../Forms/Results/DMAPA2Form";
import DMAPA3IncrCovForm from "../Forms/Results/DMAPA3IncrCovForm";
import DMAPA123Form from "../Forms/Results/DMAPA123Form";
import DMAPA3UptakeRateByCountryForm from "../Forms/Results/DMAPA3UptakeRateByCountryForm";
import DMMalePopByAgeGroupForm from "../Forms/Results/DMMalePopByAgeGroupForm";

class DMAppContentCustom extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        handleLogin: PropTypes.func,
        loginSuccess: PropTypes.func,
        forgotPassword: PropTypes.func,
        createAccount: PropTypes.func,

        navComboBoxHeight: PropTypes.number,

        processingServerCall: PropTypes.bool,

        pageID: PropTypes.string,
        onPageChange: PropTypes.func,

        DM: PropTypes.object,
        handleTargBySNU: PropTypes.func,
    };

    static defaultProps = {
        handleLogin: () => console.log("handleLogin"),
        loginSuccess: () => console.log("loginSuccess"),
        forgotPassword: () => console.log("forgotPassword"),
        createAccount: () => console.log("createAccount"),

        navComboBoxHeight: 35,

        processingServerCall: false,

        pageID: PropTypes.pageID,
        onPageChange: () => console.log("onPageChange"),

        DM: PropTypes.object,
        handleTargBySNU: () => console.log("handleTargBySnu"),

        covTable: {},
        setCovTable: () => console.log("setCovTable"),
        createTable: () => console.log("createTable"),
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    renderPage = () => {
        let page;

        const props = this.props;
        const pageID = props.pageID;
        const DM = props.DM;
        const navComboBoxHeight = props.navComboBoxHeight;

        const results = DM.results;
        const selectedCountryMstID = DM.selectedCountryMstID;
        const selectedFiscalYearStart = DM.selectedFiscalYearStart;
        const selectedProvinceCurrID = DM.selectedProvinceCurrID;
        const selectedSNU_CurrID = DM.selectedSNU_CurrID;
        const selectedTargetYear = DM.selectedTargetYear;
        const showGlobalOutputsBool = DM.showGlobalOutputsBool;
        const VMMC_Coverage = DM.VMMC_Coverage;
        const handleTargBySNU = props.handleTargBySNU;

        switch (pageID) {
            case GBConst.GBLoginFormPg:
                page = (
                    <GBLoginForm
                        onPageChange={props.onPageChange}
                        onHandleLogin={props.handleLogin}
                        onLoginSuccess={props.loginSuccess}
                        onHandleForgotPassword={props.forgotPassword}
                        onHandleCreateAccount={props.createAccount}
                        showCreateAccountBtn={false}
                        showForgotPasswordLabel={false}
                    />
                );
                break;

            case DMConst.DMWelcomeFormPg:
                page = <DMWelcomeForm />;
                break;
            case DMConst.DMCoverageFormPg:
                page = (
                    <DMCoverageForm
                        selectedCountryMstID={selectedCountryMstID}
                        DM={DM}
                        handleTargBySNU={handleTargBySNU}
                        covTable={props.covTable}
                        setCovTable={props.setCovTable}
                        createTable={props.createTable}
                    />
                );
                break;

            case DMConst.DMDashboardFormPg:
                page = <DMDashboardForm selectedCountryMstID={selectedCountryMstID} />;
                break;

            case DMConst.DMTargVsPriorAchievFormPg:
                page = (
                    <DMTargVsPriorAchievForm
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                        selectedSNU_CurrID={selectedSNU_CurrID}
                    />
                );
                break;

            case DMConst.DMProgCovByAgeGroupFormPg:
                page = (
                    <DMProgCovByAgeGroupForm
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                        selectedSNU_CurrID={selectedSNU_CurrID}
                    />
                );
                break;

            case DMConst.DMProgCovBySNUFormPg:
                page = (
                    <DMProgCovBySNUForm
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                    />
                );
                break;

            case DMConst.DMCovByAgeSNUFormPg:
                page = (
                    <DMCovByAgeSNUForm
                        results={results}
                        selectedCountryMstID={selectedCountryMstID}
                        selectedFiscalYearStart={selectedFiscalYearStart}
                        selectedProvinceCurrID={selectedProvinceCurrID}
                        selectedSNU_CurrID={selectedSNU_CurrID}
                        selectedTargetYear={selectedTargetYear}
                        showGlobalOutputsBool={showGlobalOutputsBool}
                        VMMC_Coverage={VMMC_Coverage}
                    />
                );
                break;

            case DMConst.DMImpactHIVInfAvertedFormPg:
                page = (
                    <DMImpactHIVInfAvertedForm
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                    />
                );
                break;

            case DMConst.DMVMMCsReqPerHIVInfAvertedFormPg:
                page = (
                    <DMVMMCsReqPerHIVInfAvertedForm
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                    />
                );
                break;

            case DMConst.DMProgCovByCountryFormPg:
                page = (
                    <DMProgCovByCountryForm
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                        selectedSNU_CurrID={selectedSNU_CurrID}
                    />
                );
                break;

            case DMConst.DMCovTableByAgeCountryFormPg:
                page = (
                    <DMCovTableByAgeCountryForm
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                        selectedCountryMstID={selectedCountryMstID}
                        selectedFiscalYearStart={selectedFiscalYearStart}
                        selectedProvinceCurrID={selectedProvinceCurrID}
                        selectedSNU_CurrID={selectedSNU_CurrID}
                        selectedTargetYear={selectedTargetYear}
                        showGlobalOutputsBool={showGlobalOutputsBool}
                        VMMC_Coverage={VMMC_Coverage}
                    />
                );
                break;

            case DMConst.DMAPA1FormPg:
                page = (
                    <DMAPA1Form
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                        selectedSNU_CurrID={selectedSNU_CurrID}
                    />
                );
                break;
            case DMConst.DMAPA2FormPg:
                page = (
                    <DMAPA2Form
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                        selectedSNU_CurrID={selectedSNU_CurrID}
                    />
                );
                break;

            case DMConst.DMAPA3IncrCovFormPg:
                page = (
                    <DMAPA3IncrCovForm
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                        selectedSNU_CurrID={selectedSNU_CurrID}
                    />
                );
                break;

            case DMConst.DMAPA123FormPg:
                page = (
                    <DMAPA123Form
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                        selectedSNU_CurrID={selectedSNU_CurrID}
                    />
                );
                break;

            case DMConst.DMAPA3UptakeRateByCountryFormPg:
                page = (
                    <DMAPA3UptakeRateByCountryForm
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                        selectedSNU_CurrID={selectedSNU_CurrID}
                    />
                );
                break;

            case DMConst.DMMalePopByAgeGroupFormPg:
                page = (
                    <DMMalePopByAgeGroupForm
                        navComboBoxHeight={navComboBoxHeight}
                        results={results}
                        selectedCountryMstID={selectedCountryMstID}
                        selectedFiscalYearStart={selectedFiscalYearStart}
                        selectedProvinceCurrID={selectedProvinceCurrID}
                        selectedSNU_CurrID={selectedSNU_CurrID}
                        selectedTargetYear={selectedTargetYear}
                        showGlobalOutputsBool={showGlobalOutputsBool}
                        VMMC_Coverage={VMMC_Coverage}
                    />
                );
                break;

            default:
                page = <div>I DON'T EXIST YET! MY PAGE ID IS "{pageID}"</div>;
                break;
        }

        return page;
    };

    render() {
        try {
            return <div>{this.renderPage()}</div>;
        } catch (exception) {
            return (
                <div
                    className={"DMAppContentCustomDiv"}
                    key={"DMAppContentCustomDiv"}
                >
                    <h3 key={"DMAppContentCustomDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMAppContentCustom;
